import React from 'react';
import classes from '../index.module.scss';

const BusinessTableHeader = () => {
  return (
    <tr>
      <th className={`${classes.No_Wrap}`}>
        Business Name
      </th>
      <th>
        POC
      </th>
      <th>
        Options
      </th>
    </tr>
  )
}

export default BusinessTableHeader;